import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = useDispatch<AppDispatch>;

export { useShowResponseStatus } from './use-show-response-status';
export { useResponsive } from './use-responsive';
